/**
 * WHAT A SEARCH TERM IS, from its shape — one rule for every place an operator types one.
 *
 * Support starts with a caller reading out a phone number, an email, or the code on their SMS. The
 * command palette names what was typed and offers the one search that answers it; an orders search
 * box picks its field from the same rule, so a phone number typed while it says "by name" is searched
 * as a phone number. Nothing here queries: it only says which indexed field the text belongs to.
 *
 * Shapes, from the data: order codes are 11–12 letters and digits (13,734 + 103 in the last 120 days
 * on prod); a phone is 9–13 digits however it is spaced or prefixed; an email has an @. Anything else
 * is left to the field already chosen (a name, by default).
 */
export const searchShape = (raw) => {
  const q = String(raw || '').trim();
  if (!q) return null;
  if (/^[^\s@]+@[^\s@]*$/.test(q)) return { qf: 'email', q: q.toLowerCase(), what: 'email', shown: q };
  const digits = q.replace(/\D/g, '');
  if (/^[+\d\s().-]+$/.test(q) && digits.length >= 9 && digits.length <= 13) return { qf: 'phone', q: digits, what: 'phone', shown: q };
  // An order code as stored or as the console shows it ("SYYM-VGRU3R2D", dashed every 4).
  const code = q.replace(/[\s-]/g, '');
  if (/^[A-Z0-9]{11,12}$/i.test(code) && /\d/.test(code) && /[A-Z]/i.test(code)) return { qf: 'code', q: code.toUpperCase(), what: 'order ID', shown: code.toUpperCase() };
  return null;
};
